import {  useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Popover, Dropdown, Menu, Divider } from 'antd';
import { DeleteOutlined, EditOutlined, DownOutlined } from '@ant-design/icons';
import { businessActions } from '../../redux/actions';
import './styles.scss';

const BusinessCaseDropdown = ({
    handleStartEdit,
    editingKey,
    handleSelectBusinessCase,
    showEdit,
    showDelete,
    allowNone = false,
    noneLabel = 'None (no business case)',
    selectedBusinessCaseId = null,
}) => {
    const dispatch = useDispatch();
    const businessCases = useSelector((state) => state.business.businessCases);
    const deletingBusinessCase = useSelector((state) => state.business.deletingBusinessCase);

    const [open, setOpen] = useState(false);
    const [deletePopupForId, setDeletePopupForId] = useState(null);

    const handleDelete = (bc) => {
        if (bc && !deletingBusinessCase) {
      dispatch(businessActions.deleteBusinessCase(bc));
    }
  };
  
  const selectedKeys =
  selectedBusinessCaseId == null ? [] : [String(selectedBusinessCaseId)];


     const onMenuClick = ({ key }) => {
    // close any open delete popover
    setDeletePopupForId(null);

    if (key === 'none') {
       handleSelectBusinessCase(null);
       setOpen(false);
       return;
    }

    const bc = (businessCases || []).find(b => String(b.business_case_id) === key);
    if (!bc) return;
    if (editingKey !== bc.business_case_id) handleSelectBusinessCase(bc);
    setOpen(false);
  };
  
  const hasBC = selectedBusinessCaseId != null;

  const selectedBc = useMemo(() => {
  if (!Array.isArray(businessCases) || selectedBusinessCaseId == null) return null;
  return businessCases.find(b => String(b.business_case_id) === String(selectedBusinessCaseId)) || null;
}, [businessCases, selectedBusinessCaseId]);

const buttonLabel =
  selectedBusinessCaseId == null
    ? "Select business case"
    : (selectedBc?.name ?? "Select business case");

    useEffect(() => {
  if (selectedBusinessCaseId == null) return;
  if (!Array.isArray(businessCases)) return;

  const exists = businessCases.some(
    (b) => String(b.business_case_id) === String(selectedBusinessCaseId)
  );

  if (!exists) handleSelectBusinessCase(null);
}, [businessCases, selectedBusinessCaseId, handleSelectBusinessCase]);
  
    const items = [
    ...(allowNone ? [{ key: 'none', label: noneLabel }] : []),
    ...(Array.isArray(businessCases)
      ? businessCases.map((bc) => ({
          key: String(bc.business_case_id),
          label: (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ flex: 1 }}>{bc.name}</span>

              {showDelete && (
                <Popover
                  open={deletePopupForId === bc.business_case_id}
                  onOpenChange={(open) => {
                    // control popover per row; prevent parent dropdown from interfering
                    setDeletePopupForId(open ? bc.business_case_id : null);
                  }}
                  trigger="click"
                  placement="left"
                  zIndex={2000}
                  getPopupContainer={() => document.body}
                  content={
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Button
                        type="text"
                        style={{ color: 'red' }}
                        onClick={(e) => {
                          e.stopPropagation(); // keep dropdown stable
                          handleDelete(bc);
                          setDeletePopupForId(null);
                          handleSelectBusinessCase(null); // switch to None after delete (optional)
                        }}
                      >
                        Delete
                      </Button>
                      <Button
                        type="text"
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeletePopupForId(null);
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  }
                >
                  <Button
                    type="text"
                    onClick={(e) => {
                      e.stopPropagation(); // don’t close dropdown
                      setDeletePopupForId(bc.business_case_id);
                    }}
                  >
                    <DeleteOutlined style={{ fontSize: '150%' }} />
                  </Button>
                </Popover>
              )}

              {showEdit && (
                <Button
                  type="text"
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpen(false); 
                    handleStartEdit?.(bc);
                  }}
                >
                  <EditOutlined style={{ fontSize: '150%' }} />
                </Button>
              )}
            </div>
          ),
        }))
      : []),
  ];

  return (
    <Dropdown
    open={open}
      onOpenChange={(nextOpen) => {
        // if a delete popover is open, keep dropdown open unless user explicitly closes
        setOpen(nextOpen);
      }}
      menu={{ items, selectable: true, selectedKeys, onClick: onMenuClick }}
      trigger={['click']}
      placement="bottomLeft"
      
    >
      <Button
      className={hasBC ? 'bc-trigger bc-trigger--selected' : 'bc-trigger'}
        style={{
          minWidth: '300.5px',
          minHeight: '50px',
          marginLeft: '25px',
          textAlign: 'center',
          position: 'relative',
          color: hasBC ? '#fff' : '#000',
        }}
      >
        {buttonLabel}
        <DownOutlined style={{ position: 'absolute', right: 15, top: 12 }} />
      </Button>
    </Dropdown>
  );
};

export default BusinessCaseDropdown;